import { render } from "./highschoolForm.vue?vue&type=template&id=5e6cfde4&scoped=true"
import script from "./highschoolForm.vue?vue&type=script&lang=js"
export * from "./highschoolForm.vue?vue&type=script&lang=js"

import "./highschoolForm.vue?vue&type=style&index=0&id=5e6cfde4&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6cfde4"]])

export default __exports__